// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__IPNM4","description":"PatientConsentPreview_description__1HIBf"};